import React from 'react';

export const RenterContext = React.createContext({
  renterData: null,
})

export const RenterInformationContext = React.createContext({})